module.exports = __webpack_public_path__ + "img/introductie_01_beweegbuddies.822cbca2.png";